export default "__VITE_ASSET__DfFYP8VA__"